











import { Vue, Component, Prop } from 'vue-property-decorator'
import Printer from './TaiwanPrinter.vue'
import type { TaiwanEnroll } from '@/models/enrolls/taiwanEnroll'

@Component({
  components: { Printer }
})
export default class PersonalInfomationForm extends Vue {
  @Prop({ required: true }) value!: TaiwanEnroll
  @Prop({ default: false }) print!: boolean
  @Prop({ default: '' }) title!: string
}
